import type { UiLinkProps } from "@sarva/ui";
import { forwardRef } from "react";
import { Link, useInRouterContext } from "react-router-dom";

/**
 * `@sarva/ui`'s internal links, through the router — so a breadcrumb, a linked stat card
 * or a linked row navigates in place instead of reloading the whole SPA. Outside a router
 * (a bare component test) it degrades to the plain anchor the package would have drawn.
 */
export const RouterUiLink = forwardRef<HTMLAnchorElement, UiLinkProps>(function RouterUiLink(
  { href, ...rest },
  ref,
) {
  const inRouter = useInRouterContext();
  if (!inRouter) return <a ref={ref} href={href} {...rest} />;
  return <Link ref={ref} to={href} {...rest} />;
});
